import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import App from "./App";
import "bootstrap/dist/css/bootstrap.css";
import "./core/theme/theme.css";
import "./core/constants/fonts.css";
import "./core/constants/spaces.css";
import reportWebVitals from "./reportWebVitals";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
